/* 6fourteen · Motion revamp (MAAZ, 2026-10-30). Bag drawer, product forms, the Motion pair, search. Reads the live cart only. */
(() => {
  const SX = window.SX || { pair: [], routes: {} };
  const R = SX.routes;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function money(cents) {
    const fmt = SX.money || '${{amount}}';
    const n = (cents || 0) / 100;
    const whole = Number.isInteger(n);
    const two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return two.replace('.', ',');
      return whole ? two.replace(/\.00$/, '') : two;
    }).replace(/<[^>]+>/g, '');
  }

  /* ---------- toast + drawers ---------- */
  let tt;
  function toast(msg) {
    const t = $('#sx-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2400);
  }
  function openDrawer(id) {
    closeAll(true);
    const d = $('#' + id); if (!d) return;
    d.classList.add('on'); $('#sx-scrim').classList.add('on'); document.body.classList.add('sx-lock');
    const f = d.querySelector('input,button,select,a'); if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
  }
  function closeAll(keepScrim) {
    $$('.drawer.on').forEach(d => d.classList.remove('on'));
    if (!keepScrim) { $('#sx-scrim') && $('#sx-scrim').classList.remove('on'); document.body.classList.remove('sx-lock'); }
  }

  /* ---------- the Motion pair ---------- */
  const pairByHandle = h => SX.pair.find(p => p.handle === h);
  const otherPair = h => SX.pair.find(p => p.handle !== h);
  function sizeOptions(p, selected) {
    return '<option value="">Size</option>' + p.variants.map(v =>
      `<option value="${v.id}"${v.available ? '' : ' disabled'}${selected && v.title === selected && v.available ? ' selected' : ''}>${esc(v.label || v.title)}${v.available ? '' : ' (sold out)'}</option>`).join('');
  }

  /* ---------- cart ---------- */
  let cart = null;
  async function getCart() {
    const r = await fetch(R.cartJs, { headers: { Accept: 'application/json' } });
    cart = await r.json(); return cart;
  }
  async function addItems(items, opts = {}) {
    const btn = opts.button; if (btn) btn.classList.add('is-busy');
    try {
      const r = await fetch(R.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const j = await r.json();
      if (!r.ok) { toast(j.description || j.message || 'That could not be added.'); return false; }
      await renderCart();
      if (opts.open !== false) openDrawer('sx-bag');
      return true;
    } catch (e) { toast('Could not reach the store. Try again.'); return false; }
    finally { if (btn) btn.classList.remove('is-busy'); }
  }
  async function changeLine(line, quantity) {
    const r = await fetch(R.change, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    const j = await r.json();
    if (!r.ok) toast(j.description || 'That could not be changed.');
    await renderCart();
  }

  function lineImage(item) {
    const p = pairByHandle(item.handle);
    if (p && p.img) return p.img;
    return item.image ? item.image + (item.image.includes('?') ? '&' : '?') + 'width=200' : '';
  }

  function cartHTML(c, where) {
    const pairQty = c.items.filter(i => pairByHandle(i.handle)).reduce((n, i) => n + i.quantity, 0);
    if (!c.item_count) {
      return { body: `<div class="cart-empty"><p>Your bag is empty.</p><a class="btn btn-ink" href="${esc((SX.pair[0] || {}).url || '/collections/all')}">Shop the Motion Set</a></div>`, foot: '' };
    }
    let body = c.items.map((i, k) => {
      const variant = i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '';
      const isPre = !!pairByHandle(i.handle);
      const was = i.original_line_price > i.final_line_price ? `<s>${money(i.original_line_price)}</s>` : '';
      return `<div class="line"><a class="ph" href="${esc(i.url)}"><img src="${esc(lineImage(i))}" alt="" width="76" height="76" loading="lazy"></a>
        <div><b>${esc(i.product_title)}</b><small>${variant ? 'Size ' + esc(variant) : ''}${variant && isPre ? ' · ' : ''}${isPre ? 'Preorder' : ''}</small>
        <div><span class="qty"><button type="button" data-line="${k + 1}" data-q="${i.quantity - 1}" aria-label="One less">&minus;</button><span>${i.quantity}</span><button type="button" data-line="${k + 1}" data-q="${i.quantity + 1}" aria-label="One more">+</button></span><button class="rm" type="button" data-line="${k + 1}" data-q="0">Remove</button></div></div>
        <div class="lp">${was}${money(i.final_line_price)}</div></div>`;
    }).join('');

    if (SX.pairOn && SX.pair.length === 2) {
      if (pairQty === 1) {
        const have = c.items.find(i => pairByHandle(i.handle));
        const other = otherPair(have.handle);
        const gap = SX.pairPrice - have.final_line_price / have.quantity;
        body += `<div class="nudge"><div class="ph"><img src="${esc(other.img)}" alt=""></div><div><b>Add ${esc(other.colour)}: both for ${money(SX.pairPrice)}</b><small>${money(gap)} more for the second set.</small></div>
          <div class="row"><select aria-label="${esc(other.colour)} size" data-nudge-size>${sizeOptions(other, have.variant_title)}</select><button class="btn" type="button" data-nudge-add>Add</button></div></div>`;
      } else if (pairQty >= 2 && c.total_discount > 0) {
        body += `<div class="paired">Pair price unlocked. Your discount is in the total.</div>`;
      }
    }

    const original = c.items.reduce((n, i) => n + i.original_line_price, 0);
    const titles = new Set();
    c.items.forEach(i => (i.line_level_discount_allocations || []).forEach(a => titles.add(a.discount_application.title)));
    (c.cart_level_discount_applications || []).forEach(a => titles.add(a.title));
    const disc = original - c.total_price;
    const foot = `<div class="tot"><span>Subtotal</span><span>${money(original)}</span></div>
      ${disc > 0 ? `<div class="tot"><span>${esc([...titles].join(', ') || 'Discount')}</span><span class="disc">&minus;${money(disc)}</span></div>` : ''}
      <div class="tot"><span>Shipping</span><span>Free in the US</span></div>
      <div class="tot big"><span>Total</span><span>${money(c.total_price)}</span></div>
      <form action="${esc(R.cart)}" method="post"><button class="btn btn-ink" type="submit" name="checkout" style="width:100%">Checkout</button></form>`;
    return { body, foot };
  }

  async function renderCart() {
    const c = await getCart();
    $$('[data-cart-count]').forEach(el => { el.textContent = c.item_count; el.dataset.n = c.item_count; });
    const targets = [['#sx-bag-body', '#sx-bag-foot'], ['#sx-cartpage-body', '#sx-cartpage-foot']];
    targets.forEach(([b, f]) => {
      const B = $(b), F = $(f); if (!B) return;
      const h = cartHTML(c); B.innerHTML = h.body; F.innerHTML = h.foot;
      $$('[data-line]', B).forEach(el => el.addEventListener('click', () => changeLine(+el.dataset.line, +el.dataset.q)));
      const na = $('[data-nudge-add]', B);
      if (na) na.addEventListener('click', () => { const v = $('[data-nudge-size]', B).value; if (!v) { toast('Pick a size'); return; } addItems([{ id: +v, quantity: 1 }], { button: na, open: false }); });
    });
    return c;
  }

  /* ---------- product forms (PDP + homepage colour cards) ---------- */
  function bindForm(root) {
    const data = JSON.parse($('script[data-variants]', root).textContent);
    const selected = data.options.map((o, i) => (data.preselect || [])[i] || null);
    const chips = $$('[data-opt]', root);
    const btn = $('[data-add]', root), need = $('[data-need]', root), priceEl = $$('[data-price]', root.closest('[data-pdp]') || root);
    const findVariant = sel => data.variants.find(v => v.options.every((o, i) => o === sel[i]));
    function refresh() {
      chips.forEach(ch => {
        const i = +ch.dataset.opt, val = ch.dataset.val;
        const trial = selected.slice(); trial[i] = val;
        const possible = data.variants.some(v => v.available && v.options.every((o, j) => trial[j] == null || o === trial[j]));
        ch.classList.toggle('is-out', !possible);
        ch.setAttribute('aria-pressed', selected[i] === val);
      });
      const v = selected.every(Boolean) ? findVariant(selected) : null;
      root.sxVariant = v && v.available ? v : null;
      if (!btn) return;
      if (!v) { btn.textContent = btn.dataset.choose || 'Choose a size'; btn.disabled = !btn.hasAttribute('data-soft'); }
      else if (!v.available) { btn.textContent = 'Sold out'; btn.disabled = true; }
      else { btn.textContent = `${btn.dataset.label || 'Add to bag'} · ${money(v.price)}${data.options.length === 1 && root.hasAttribute('data-show-size') ? ' · ' + v.options[0] : ''}`; btn.disabled = false; }
      if (v) priceEl.forEach(p => p.textContent = money(v.price));
      if (v && root.hasAttribute('data-pdp-form')) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
        if (v.image && window.sxShowImage) window.sxShowImage(v.image);
      }
      root.dispatchEvent(new CustomEvent('sx:variant', { detail: root.sxVariant }));
    }
    chips.forEach(ch => ch.addEventListener('click', () => {
      if (ch.classList.contains('is-out') && data.options.length === 1) return;
      selected[+ch.dataset.opt] = ch.dataset.val; if (need) need.textContent = ''; refresh();
    }));
    if (btn) btn.addEventListener('click', () => {
      if (!root.sxVariant) { if (need) need.textContent = 'Pick a ' + data.options.filter((o, i) => !selected[i]).join(' and ').toLowerCase() + ' first.'; return; }
      addItems([{ id: root.sxVariant.id, quantity: 1 }], { button: btn });
    });
    root.sxNeed = () => { if (need) need.textContent = 'Pick a ' + (data.options.filter((o, i) => !selected[i])[0] || 'size').toLowerCase() + ' first.'; };
    refresh();
  }

  /* ---------- PDP gallery, upsell, sticky ---------- */
  function bindPdp(pdp) {
    const imgs = $$('.main-ph img', pdp), thumbs = $$('.thumbs button', pdp);
    const show = i => { imgs.forEach((im, j) => im.classList.toggle('is-on', j === i)); thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i)); };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    show(0);
    window.sxShowImage = src => { const k = imgs.findIndex(im => im.dataset.src && src && src.split('?')[0].endsWith(im.dataset.src.split('?')[0].split('/').pop())); if (k > -1) show(k); };
    const form = $('[data-form]', pdp);
    const up = $('[data-upsell]', pdp);
    if (up) $('[data-up-add]', up).addEventListener('click', e => {
      const v2 = $('[data-up-size]', up).value;
      if (!form.sxVariant) { form.sxNeed(); $('[data-form]', pdp).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (!v2) { toast('Pick a size for the second set'); return; }
      addItems([{ id: form.sxVariant.id, quantity: 1 }, { id: +v2, quantity: 1 }], { button: e.currentTarget });
    });
    const sb = $('[data-sticky-add]');
    if (sb) sb.addEventListener('click', () => {
      if (!form.sxVariant) { form.sxNeed(); $('[data-form]', pdp).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      addItems([{ id: form.sxVariant.id, quantity: 1 }], { button: sb });
    });
  }

  /* ---------- search ---------- */
  let st;
  function bindSearch() {
    const input = $('#sx-q'), out = $('#sx-sres'); if (!input) return;
    input.addEventListener('input', () => {
      clearTimeout(st); const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      st = setTimeout(async () => {
        try {
          const r = await fetch(`${R.suggest}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const j = await r.json(); const ps = (j.resources && j.resources.results.products) || [];
          out.innerHTML = ps.length ? ps.map(p => `<a href="${esc(p.url)}"><img src="${esc(p.image || p.featured_image && p.featured_image.url || '')}" alt="" loading="lazy"><b>${esc(p.title)}</b><span>${money(Math.round(parseFloat(p.price) * 100))}</span></a>`).join('')
            + `<a href="${esc(R.search)}?q=${encodeURIComponent(q)}&type=product" style="grid-template-columns:1fr;font-size:12px;letter-spacing:.12em;text-transform:uppercase">See all results</a>`
            : `<p style="color:var(--muted)">No sets match “${esc(q)}”.</p>`;
        } catch (e) { out.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    $$('[data-open-drawer]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openDrawer(b.dataset.openDrawer); }));
    $$('[data-close]').forEach(b => b.addEventListener('click', () => closeAll()));
    const scrim = $('#sx-scrim'); if (scrim) scrim.addEventListener('click', () => closeAll());
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
    $$('[data-form]').forEach(bindForm);
    $$('[data-pdp]').forEach(bindPdp);
    const pairAdd = $('[data-pair-add]');
    if (pairAdd) pairAdd.addEventListener('click', () => {
      const ids = $$('[data-pair-size]').map(s => s.value);
      if (ids.some(v => !v)) { toast('Pick a size for each colour'); return; }
      addItems(ids.map(id => ({ id: +id, quantity: 1 })), { button: pairAdd });
    });
    $$('[data-pair-size]').forEach(s => { const p = pairByHandle(s.dataset.pairSize); if (p) s.innerHTML = sizeOptions(p); });
    const sort = $('[data-sort]'); if (sort) sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u; });
    bindSearch();
    renderCart().catch(() => {});
    if (location.search.includes('sx-open-bag')) openDrawer('sx-bag');
  });
  window.SXapi = { addItems, renderCart, openDrawer, money };
})();
